var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 12.4h-1.92V9.308c0-.748-.108-1.708-1.12-1.708s-1.172.8-1.172 1.652V12.4H6.92V6h1.76v.852h.052C9 6.372 9.64 6 10.6 6c1.652 0 2.188.8 2.348 1.972.052.268.052.588.052.96V12.4zM4.52 5.04c-.64 0-1.12-.532-1.12-1.12 0-.64.532-1.12 1.12-1.12.64 0 1.12.532 1.12 1.12 0 .64-.48 1.12-1.12 1.12zM3.4 12.348h2.24V6H3.4v6.348zM12.8 0H3.2A3.2 3.2 0 000 3.2v9.6A3.2 3.2 0 003.2 16h9.6a3.2 3.2 0 003.2-3.2V3.2A3.2 3.2 0 0012.8 0z","fillRule":"evenodd"}));
}

Linkedin.defaultProps = {"width":"16","height":"16"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
